/**
 * Nuwa (~48 KB) off the critical path: loaded on first interaction or at idle,
 * and a launcher click landing before the load is replayed afterwards. Her URL
 * comes from data-src on this tag, since an asset cannot run Liquid.
 */
(function () {
  var me = document.currentScript;
  if (!me || window.bqOrienteurLazy) return;
  window.bqOrienteurLazy = true;
  var src = me.dataset.src;
  if (!src) return;

  var el = null;
  function load(cb) {
    if (!el) {
      el = document.createElement('script');
      el.src = src;
      document.head.appendChild(el);
    }
    if (cb) {
      if (window.bqOrienteurInit) cb();
      else el.addEventListener('load', cb);
    }
  }

  ['pointerdown', 'keydown'].forEach(function (t) {
    window.addEventListener(t, function () { load(); }, { once: true, passive: true });
  });

  // Not on scroll: reading the page is not asking for Nuwa. Idle, and only once
  // the first screen has had its bandwidth.
  setTimeout(function () {
    (window.requestIdleCallback || function (f) { f(); })(function () { load(); });
  }, 5000);

  // The mobile bubble still surfaces on the first scroll, without the script.
  var bubble = document.querySelector('.bq-orienteur__launcher');
  if (bubble) {
    var onScroll = function () {
      if (window.scrollY <= 64) return;
      bubble.classList.add('is-revealed');
      window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  document.addEventListener('click', function (e) {
    if (window.bqOrienteurInit) return;
    var t = e.target.closest && e.target.closest('[data-bq-orienteur-open]');
    if (t) load(function () { t.click(); });
  });
})();
